module.exports = __webpack_public_path__ + "static/media/indexBack.ecc745e2.jpg";